import {
  BOXLESS,
  PRINTERLESS_MAIL,
  MAIL,
  HOME_PICKUP,
  STORE,
  NARVAR_CONCIERGE,
} from './returnMethods';

export const SAVE_SUCCESS = 'save_success';
export const SAVE_ERROR = 'save_error';
export const EMAIL_MISMATCH = 'email_mismatch';

export const RETURN_METHOD_PREFERENCES_LIST = [
  BOXLESS,
  PRINTERLESS_MAIL,
  MAIL,
  HOME_PICKUP,
  STORE,
  NARVAR_CONCIERGE,
];
export const PREFERENCES_BASE = {
  return_methods: [],
  carriers: [],
  locations: [],
};
